import React from "react"
import config from 'react-global-configuration';
import {  Link } from 'react-router-dom'



/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class HeaderAll extends React.Component {

  constructor(){
    super()

    this.state = {

    }
  }

  componentDidMount(){

  }

  componentWillUnmount(){

  }

  /* Handlers */


  render(){


    return(
      <header>
          <a href="/club/"><img src={`${process.env.PUBLIC_URL}/images/logo.png`} /></a>
          <nav>
            <div><a href="/club/">TOP</a></div>
            <div><a href="/club/about">入会案内</a></div>
            <div><a href="/club/login">会員ログイン</a></div>
          </nav>
      </header>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/HeaderAll.js